export default __webpack_public_path__ + "static/media/pantry2-before1-480w.78aa4c48.webp";